import { useMemo } from 'react';
import PratusSelect, {
  type OptionType,
} from 'components/DesignSystems/New/PratusSelect';
import type { InternalLayer } from 'hooks/internalLayer/types';
import { formatDateTime } from 'components/IAP/Resources/utils/dateUtils';
import { useListInternalLayerVersionsQuery } from 'hooks/internalLayerVersion/useListInternalLayerVersionsQuery';
import { useUscgMapContext } from './UscgMapContext';

export function InternalLayerVersionSelect({
  layer,
}: {
  layer: InternalLayer;
}) {
  const { getSelectedVersionForLayer, setSelectedInternalLayerVersion } =
    useUscgMapContext();

  const selectedVersion = getSelectedVersionForLayer(layer.id);

  const { data: versionsData } = useListInternalLayerVersionsQuery({
    filter: { internalLayerId: layer.id },
  });

  const versionOptions: OptionType[] = useMemo(() => {
    const data = versionsData?.data;
    if (!data) return [];

    return data.map((v) => ({
      value: v.id,
      label: `v${v.versionNumber} (${v.approval?.approvalStatus ?? 'UNKNOWN'}) ${formatDateTime(v.updatedAt)}`,
    }));
  }, [versionsData?.data]);

  const selectedVersionOption = versionOptions.find(
    (o) => o.value === selectedVersion?.id
  );

  return (
    <div className="d-flex flex-column gap-2">
      <PratusSelect
        options={versionOptions}
        value={selectedVersionOption}
        onChange={(newValue) => {
          if (!newValue) return;
          if ('value' in newValue) {
            const internalLayerVersion = versionsData?.data?.find(
              (v) => v.id === newValue.value
            );
            if (!internalLayerVersion) return;

            setSelectedInternalLayerVersion(layer.id, internalLayerVersion);
          }
        }}
        isMulti={false}
      />
    </div>
  );
}
